import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import ShowDocumentComponent from '../components/ShowDocumentComponent';

import { getDocument } from '../../DocumentLibrary/actions';

const ShowDocumentContainer = (props) => {
  const { document, getDocument, imgPreviewUrl } = props;

  if (!document?.id) return null;

  const showDocument = async (documentId) => {
    const document = await getDocument(documentId);
    if (document?.data) {
      const { url, type } = document.data;
      const isImg = type.includes('image');
      if (!isImg) {
        return window.open(url);
      }
    }
    return null;
  };

  const imgUrl = imgPreviewUrl?.[document?.id];

  const componentProps = {
    document,
    showDocument,
    imgUrl,
  };

  return <ShowDocumentComponent {...componentProps} />;
};

ShowDocumentContainer.defaultProps = {
  document: null,
};

ShowDocumentContainer.propTypes = {
  document: PropTypes.instanceOf(Object),
  getDocument: PropTypes.func.isRequired,
  imgPreviewUrl: PropTypes.instanceOf(Object),
};

const mapStateToProps = ({ messages: { imgPreviewUrl } }) => ({
  imgPreviewUrl,
});

const mapDispatchToProps = (dispatch) => ({
  getDocument: (id) => getDocument(dispatch, id),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ShowDocumentContainer);
